import React, { useState, useRef, useEffect } from "react";
import "./Header.css";
import human from "../../Assets/img/Human.svg";
import { useNavigate } from "react-router-dom";
import LogoImg from '../../Assets/img/Logo_Image.svg';
import { Menu} from "lucide-react";
import { useSidebarToggle } from "../Sidebar/Sidebar";

const Header = () => {
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const [userImage, setUserImage] = useState(human);
  const menuRef = useRef(null);
  const { isOpen, toggleSidebar } = useSidebarToggle();

  useEffect(() => {
    try {
      const savedUser = sessionStorage.getItem("user");
      const user = savedUser ? JSON.parse(savedUser) : null;

      if (user?.admin_image) {
        setUserImage(user.admin_image);
      }
    } catch (err) {
      console.log("Invalid user JSON");
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowLogout(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logout = () => {
    sessionStorage.removeItem("isAdminLoggedIn");
    sessionStorage.removeItem("adminUser");
    navigate("/");
  };


  return (
    <div className="page">
      <div className="headerStyle">
        <div className="titleStyle">

          <img className="companylogo" src={LogoImg} alt="Logo" />

          <button
            onClick={toggleSidebar}
            aria-label={isOpen ? "Close sidebar" : "Open sidebar"}
            aria-expanded={isOpen}
            className="hamburger-btn"
          >
            {isOpen ? <Menu size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <div className="profile-container" ref={menuRef}>
          <img
            className="iconStyle"
            src={userImage}
            alt="User Icon"
            onError={(e) => (e.target.src = human)}
            onClick={() => setShowLogout(!showLogout)}
          />

          {showLogout && (
            <div className="logout-dropdown">
              <button onClick={logout}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
